import type { FC } from 'react';
import { Button } from '../../../web/components-v2/Button';
import {
	Dialog,
	DialogBody,
	DialogFooter,
	DialogHeader,
	DialogPopup,
	DialogTitle,
} from '../../../web/components-v2/Dialog';

export const TEXTING_BLOCKED_MESSAGE =
	'Texting from Coffee is only for demo confirmations and reschedules. Book a demo with this lead first, then come back to confirm by text.';

export type TextingBlockedDialogProps = {
	open: boolean;
	onOpenChange: (open: boolean) => void;
};

export const TextingBlockedDialog: FC<TextingBlockedDialogProps> = ({ open, onOpenChange }) => (
	<Dialog open={open} onOpenChange={onOpenChange}>
		<DialogPopup>
			<DialogHeader>
				<DialogTitle>No demo on this lead yet</DialogTitle>
			</DialogHeader>
			<DialogBody>
				<p>{TEXTING_BLOCKED_MESSAGE}</p>
			</DialogBody>
			<DialogFooter>
				<Button variant='primary' onClick={() => onOpenChange(false)}>
					Got it
				</Button>
			</DialogFooter>
		</DialogPopup>
	</Dialog>
);
